module.exports = __webpack_public_path__ + "static/media/exit.99a57f33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/exit.svg
// module id = 386
// module chunks = 33